import Vue from 'vue';
import store from '../vue/store/index';

function initSingle(el, component) {
  const propsValue = el.getAttribute('data-vue-props');
  const props = propsValue ? JSON.parse(propsValue) : {};

  return new Vue({
    el,
    store,
    render: (c) => c(component, {props}),
  });
}

function init(rootComponents) {
  const elements = document.querySelectorAll('[data-vue-component]');
  const getPriority = el => parseInt(el.getAttribute('data-vue-priority'));
  [...elements]
    .sort((a, b) => getPriority(a) - getPriority(b))
    .forEach((el) => {
      const component = el.getAttribute('data-vue-component');

      if (!rootComponents.hasOwnProperty(component)) {
        console.error(`"${component}" is not a registered Vue root component.`);
        return null;
      }

      initSingle(el, rootComponents[component]);
    });
}

export default {init}
